<template>
    <div>
        <div class="action-header">
            <el-button @click="showDialog" icon="el-icon-plus" type="primary">新建代理商</el-button>
            <el-input class="input" clearable placeholder="请输入关键字" v-model="key">
                <i
                    @click="handleSearch"
                    class="el-input__icon el-icon-search btn-search"
                    slot="suffix"
                />
            </el-input>
        </div>
        <Table />
        <Pagination />
        <DialogAgent />
        <DialogAuthDetail />
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { DIALOG_ADD } from '../../libs/enum.js';
import Table from './table';
import Pagination from './pagination';
import DialogAgent from './dialog.agent';
import DialogAuthDetail from './dialog.auth-detail';

const { mapActions } = createNamespacedHelpers('agent');

export default {
    components: { Table, Pagination, DialogAgent, DialogAuthDetail },
    data() {
        return {
            key: '',
        };
    },
    methods: {
        ...mapActions([
            'changeDialog',
            'getAgents',
            'changeSearch',
            'resetState',
        ]),
        showDialog() {
            this.changeDialog({ visible: true, type: DIALOG_ADD });
        },
        handleSearch() {
            this.changeSearch({ key: this.key, page: 1 });
        },
    },
    mounted() {
        this.getAgents();
    },
    beforeDestroy() {
        this.resetState();
    },
};
</script>

<style lang="less" scoped>
.action-header {
    margin-bottom: 20px;
    .input {
        float: right;
        width: 250px;
    }
    .btn-search {
        width: 30px;
        font-size: 18px;
        cursor: pointer;
        &:hover {
            color: #409eff;
        }
    }
}
</style>
